import { yupHelper } from "lib/helpers";
import constant from "lib/constant/constant";

import {
  brandHandleSchema,
  brandNameSchema,
  citySchema,
  countrySchema,
  emailSchema,
  firstNameSchema,
  lastNameSchema,
  phoneNumberSchema,
  postalCodeSchema,
  provinceCodeSchema,
  streetAddressSchema,
} from "./schema";

const {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PHONE_NUMBER,
  STREET_ADDRESS,
  CITY,
  COUNTRY,
  POSTAL_CODE,
  PROVINCE_CODE,
  BRAND_NAME,
  BRAND_HANDLE,
} = constant;
const { validateValue, handlePromiseError } = yupHelper;

const validate = async (field, value, cms, schema) => {
  let promise = "";
  const { min = 2 } = schema || {};
  switch (field) {
    case FIRST_NAME:
      promise = validateValue(firstNameSchema(`${cms("message.error.common.firstName")}`), {
        firstName: value,
      });
      break;
    case LAST_NAME:
      promise = validateValue(lastNameSchema(`${cms("message.error.common.lastName")}`), {
        lastName: value,
      });
      break;
    case EMAIL:
      promise = validateValue(
        emailSchema(
          `${cms("message.error.common.email.requiredMessage")}`,
          `${cms("message.error.common.email.matches")}`
        ),
        { email: value }
      );
      break;
    case PHONE_NUMBER:
      promise = validateValue(
        phoneNumberSchema(
          `${cms("message.error.common.phoneNumber")}`,
          `${cms("message.error.common.minPhoneNumber")}`,
          `${cms("message.error.common.maxPhoneNumber")}`,
          `${cms("common.message.error.positiveNumber")}`
        ),
        {
          phoneNumber: value,
        }
      );
      break;
    case STREET_ADDRESS:
      promise = validateValue(streetAddressSchema(`${cms("message.error.common.streetAddress")}`), {
        streetAddress: value,
      });
      break;
    case CITY:
      promise = validateValue(citySchema(`${cms("message.error.common.city")}`), {
        city: value,
      });
      break;
    case PROVINCE_CODE:
      promise = validateValue(provinceCodeSchema(`${cms("message.error.common.provinceCode")}`), {
        provinceCode: value,
      });
      break;
    case COUNTRY:
      promise = validateValue(countrySchema(`${cms("message.error.common.country")}`), {
        country: value,
      });
      break;
    case POSTAL_CODE:
      promise = validateValue(
        postalCodeSchema(
          `${cms("message.error.common.postalCode")}`,
          `${cms("message.error.common.minPostalCode", { min })}`,
          `${cms("message.error.common.maxPostalCode")}`,
          schema
        ),
        {
          postalCode: value,
        }
      );
      break;
    case BRAND_NAME:
      promise = validateValue(brandNameSchema(`${cms("message.error.common.brandName")}`), {
        brandName: value,
      });
      break;
    case BRAND_HANDLE:
      promise = validateValue(
        brandHandleSchema(
          `${cms("message.error.common.brandHandle.required")}`,
          `${cms("message.error.common.brandHandle.match")}`
        ),
        {
          brandName: value,
        }
      );
      break;
    default:
      return "";
  }
  return handlePromiseError(promise);
};

export default validate;
